import './mask-field-date.scss'

import { defineComponent, PropType } from 'vue'

import { EntityField, EntityFieldStatus, SkinDate } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { DATE_FORMATS as AVAILABLE_DATE_FORMATS, buildSkinDateWithFormat, skinDateToInputDate } from '@skinsoft/utils';

declare const config
const DATE_FORMATS: string = config.date_formats

export const MaskFieldDate = defineComponent({
    mixins: [reactiveVueMixin],
    components: {

    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
            required: true,
        },
        fieldValue: {
            type: Object as PropType<SkinDate | null>,
        },
        editing: {
            type: Boolean,
        },
        getStatus: {
            type: Function as PropType<(entityField: EntityField) => EntityFieldStatus>,
            required: true,
        },
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-date.html'),
    computed: {
        value: {
            get(): String | null {
                let res: string | null

                if (this.fieldValue) {
                    const txtValue = (this.fieldValue?.txt) as string

                    if(txtValue) {
                        res = txtValue.split('/').reverse().join('-')
                    } else {
                        res = skinDateToInputDate(this.fieldValue)
                    }
                } else {
                    res = null;
                }

                return res
            },
            set(input: String | null) {
                let returnValue: SkinDate | null

                if (input) {
                    const reshapedDateTxt = input.split('-').reverse().join('/')
                    returnValue = buildSkinDateWithFormat(
                        reshapedDateTxt,
                        AVAILABLE_DATE_FORMATS.DD_MM_YYYY_SLASH
                    )
                } else {
                    returnValue = null
                }

                this.$emit("value-change", {
                    abstractEntity: this.entityField.abstractEntity,
                    fieldPath: this.entityField.path,
                    value: returnValue,
                })
            },
        },
    },
    methods: {
        getDateFormatOptions() {
            // for the moment, the 'locale' prop of BDatePicker override the order of the different fields (mm,DD,yyyy)
            switch(DATE_FORMATS) {
                case AVAILABLE_DATE_FORMATS.DD_MM_YYYY_SLASH:
                    return {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    }
                case AVAILABLE_DATE_FORMATS.MM_DD_YYYY_SLASH:
                    return {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                    }
                case AVAILABLE_DATE_FORMATS.YYYY_MM_DD_SLASH:
                    return {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                    }
                case AVAILABLE_DATE_FORMATS.DD_MM_YYYY_DASH:
                    return {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    }
                case AVAILABLE_DATE_FORMATS.MM_DD_YYYY_DASH:
                    return {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                    }
                case AVAILABLE_DATE_FORMATS.YYYY_MM_DD_DASH:
                    return {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                    }
                default:
                    return {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    }
            }
        },
        isReadonly(entityField: EntityField) {
            return entityField.isReadOnly || this.getStatus(entityField).disabled
        },
        infoMessage(entityField: EntityField): string | undefined {
            return this.getStatus(entityField).disabledMessage
        },
        errorMessage(entityField: EntityField): string | undefined {
            return this.getStatus(entityField).errorMessage
        },
        hasError(entityField: EntityField) {
            return this.getStatus(entityField).error
        },
    },
})
